import React, { useState, useEffect, useRef } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth, Tprovider, provider } from "../../firebase";
import "./SignIn.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useLocation } from "react-router-dom";
import { signInWithPopup } from "firebase/auth";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { signOut } from "firebase/auth";
import { sendPasswordResetEmail } from "firebase/auth";
import { Modal } from "react-bootstrap";
import { BsEmojiFrown } from "react-icons/bs";
import { baseUrl, GetToken } from "../../App";
import { IUserDetails } from "../EnrollTypes";
import { useCourses } from "../Contexts/CoursesContext";
import { useEnrollee } from "../Contexts/EnrolleeContext";
import { useUsers } from "../Contexts/UsersContext";
import { PopulateContext } from "../../App";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [geterror, setGeterror] = useState("");
  const [email2, setEmail2] = useState("");
  const [forgotpassword, setForgotpassword] = useState(false);
  const [hidepassword, setHidepassword] = useState(true);
  const [shownote, setShownote] = useState(false);
  const [notific, setNotific] = useState("");
  const [goodnote, setGoodnote] = useState(false);
  var count = useRef(0);
  let navigate = useNavigate();
  const location = useLocation();
  const [showModal, setShowModal] = React.useState(false);
  const [modalContent, setModalContent] = React.useState("");
  const [showNotification, setShowNotification] = React.useState(false);
  const [notification, setNotification] = React.useState("");
  const {Enrollee, setEnrolleeContext}= useEnrollee();
  const {User, Users, setUserContext, setUsersContext} = useUsers();
  const {courses, setCoursesContext} = useCourses();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleModalClose = () => {
    setShowModal(false);
    setModalContent(""); // Reset modal content
  };

  const handleCloseNotification = () => {
    setShowNotification(false);
    // navigate("/signup");
  };

  const populateContexts = async ()=>{
    const UserId = localStorage.getItem("UserId");
    if(UserId && UserId?.length>0){
      if(!courses){
        const Courses = await PopulateContext("Courses");
        if(Courses){
          let filteredCourses = Courses.filter((course:any) => !course.isArchive && course.isDeleted === false)
          setCoursesContext(filteredCourses);
        }
      }
        if(!User){
          const user = await PopulateContext("User");
          setUserContext(user);
        }
        if(!Users){
          const users = await PopulateContext("Users");
          setUsersContext(users);
          }
        if(!Enrollee){
          const Enrollees = await PopulateContext("Enrollees");
          setEnrolleeContext(Enrollees);
        }
    }
    else{
      if(!courses){
      const Courses = await PopulateContext("Courses");
      let filteredCourses = Courses.filter((course:any) => !course.isArchive && course.isDeleted === false)
      setCoursesContext(filteredCourses);
      }
    }
  }

  function handleSignInError(error:any) {
    switch (error.code) {
      case "auth/invalid-email":
        setShowNotification(true);
        setNotification("Invalid email address. Please try again.");
        break;
      case "auth/email-already-in-use":
        setShowNotification(true);
        setNotification("Email Address already exists, please proceed to log in.");
        break;
      case "auth/user-disabled":
        setShowNotification(true);
        setNotification("This user account has been disabled.");
        break;
      case "auth/user-not-found":
        setShowNotification(true);
        setNotification("User not found. please signup or try again.");
        break;
      case "auth/wrong-password":
        setShowNotification(true);
        setNotification("Invalid/Incorrect login details. Please try again.");
        break;
      case "auth/invalid-credential":
        setShowNotification(true);
        setNotification("Invalid/Incorrect login details. Please try again.");
      break;
      default:
        setShowNotification(true);
        setNotification("An unknown error occurred. Please try again later.");
    }
  }
  
  const SignInWithTwitter = async () => {
    const IdToken = await GetToken()
    await signInWithPopup(auth, Tprovider).then((data: any) => {
      if (data._tokenResponse.isNewUser) {
        setShowNotification(true);
        setNotification("You do not have an account: Please sign up");
        if (auth.currentUser) { auth.currentUser.delete(); }
        return;
      }}).catch((error:any)=>{
        handleSignInError(error);
        signOut(auth)
            .then(() => {
              localStorage.removeItem("UserId");
            })
            .catch((error) => {
              console.log(error);
            });
          if (auth.currentUser) { auth.currentUser.delete(); }
        return;
      });

      if(auth.currentUser?.email){
        const body = {
          email: auth.currentUser?.email.toLowerCase()
        }
        const userResponse = await axios.post(`${baseUrl}/getusersbyfield`, body, {
          headers: {
              Authorization: `Bearer ${IdToken}`,
          },
        }).catch((error) => {
          if(error.response.data.code === 404 || error.response.data.status === "No matching docs")
          {
            // console.log("No matching account with this invite code");
            setShowModal(true);
            setModalContent("Account not found! Please Signup or try again later.");
            return;
          }
          else{ console.log(error.response.data);}
        });
        let doyen:IUserDetails = userResponse?.data?.data[0];
        if (auth.currentUser?.emailVerified === false) {
          setGoodnote(false);
          count.current = 0;
          localStorage.setItem("userEmail", auth.currentUser?.email.toLowerCase());
        let APIRequest = {
          Email: auth.currentUser?.email.toLowerCase(),
        };
        await axios.post(`${baseUrl}/sendVerificationCode`, APIRequest, {
          headers: {
            Authorization: `Bearer ${IdToken}`,
          },
        });
        setShowNotification(true);
        setNotification(
          "Your email is not verified. Please verify with the code sent to your email address"
        );
        navigate("/useraction", {
          state: { userEmail: auth.currentUser?.email.toLowerCase() },
        });
        } else {
          localStorage.setItem("UserId", doyen?.id);
          await populateContexts();
          const from = location.state?.from || "/";
          navigate(from);
        }
      }
  };

  const handleReset = () => {
    setForgotpassword(true);
  };

  const donthandleReset = () => {
    setForgotpassword(false);
  };

  const handleClick = async () => {
    const IdToken = await GetToken()

    const signInResponse = await signInWithPopup(auth, provider).catch((error:any)=>{
      handleSignInError(error);
      signOut(auth)
          .then(() => {
            localStorage.removeItem("UserId");
          })
          .catch((error) => {
            console.log(error);
          });
        if (auth.currentUser) { auth.currentUser.delete(); }
      return;
    });
    if(signInResponse){
      let emailString = auth.currentUser?.email
      const body = {
        email: emailString ? emailString?.toLowerCase() : ""
      }
      const userResponse = await axios.post(`${baseUrl}/getusersbyfield`, body, {
        headers: {
            Authorization: `Bearer ${IdToken}`,
        },
      }).catch((error) => {
        if(error.response.data.code === 404 || error.response.data.status === "No matching docs")
        {
          // console.log("No matching account with this invite code");
          setShowModal(true);
          setModalContent("Account not found! Please Signup or try again later.");
          return;
        }
        else{ 
          console.log(error.response.data);
        }
      });
      let doyen:IUserDetails = userResponse?.data?.data[0];
      if (auth.currentUser?.emailVerified === false) {
        setGoodnote(false);
        count.current = 0;
        if(emailString){
        localStorage.setItem("userEmail", emailString);
        let APIRequest = {
          Email: emailString,
        };
        await axios.post(`${baseUrl}/sendVerificationCode`, APIRequest, {
          headers: {
            Authorization: `Bearer ${IdToken}`,
          },
        });
        setShowNotification(true);
        setNotification(
          "Your email is not verified. Please verify with the code sent to your email address"
        );
        navigate("/useraction", {
          state: { userEmail: emailString },
          });}
      } else {
        localStorage.setItem("UserId", doyen?.id);
        await populateContexts();
        const from = location.state?.from || "/";
        navigate(from);
      }
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

   useEffect(() => {
    document.querySelectorAll("input").forEach((input) => (input.value = ""));
  }, []);

  const toSignUp = () => {
    navigate("/signup");
  };

  const SignIn = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setGeterror("");
    setIsSubmitting(true);
    const IdToken = await GetToken()

    const signInResponse = await signInWithEmailAndPassword(auth, email, password)
    .catch((error:any)=>{
      console.log(error);
      handleSignInError(error);
      signOut(auth)
          .then(() => {
            localStorage.removeItem("UserId");
          })
          .catch((error) => {
            console.log(error);
          });
        if (auth.currentUser) { auth.currentUser.delete(); }
      return;
    });
    if(signInResponse){
      const body = {
        email: email.toLowerCase()
      }
      const userResponse = await axios.post(`${baseUrl}/getusersbyfield`, body, {
        headers: {
            Authorization: `Bearer ${IdToken}`,
        },
      }).catch((error) => {
        if(error.response.data.code === 404 || error.response.data.status === "No matching docs")
        {
          // console.log("No matching account with this invite code");
          setShowModal(true);
          setModalContent("Account not found! Please Signup or try again later.");
          return;
        }
        else{ console.log(error.response.data);}
      });
      let doyen:IUserDetails = userResponse?.data?.data[0];
      if (auth.currentUser?.emailVerified === false) {
        setGoodnote(false);
          count.current = 0;
          if(auth.currentUser.email){
           localStorage.setItem("userEmail", auth.currentUser?.email.toLowerCase());
        let APIRequest = {
          Email: auth.currentUser?.email.toLowerCase(),
        };
        await axios.post(`${baseUrl}/sendVerificationCode`, APIRequest, {
          headers: {
            Authorization: `Bearer ${IdToken}`,
          },
        });
        setShowNotification(true);
        setNotification(
          "Your email is not verified. Please verify with the code sent to your email address"
        );
        navigate("/useraction", {
          state: { userEmail: auth.currentUser?.email.toLowerCase() },
        });}
          setEmail("");
          setPassword("");
      } else {
        localStorage.setItem("UserId", doyen?.id);
        await populateContexts();
        const from = location.state?.from || "/";
        setEmail("");
        setPassword("");
        setGeterror("");
        navigate(from);
      }
    }
    setIsSubmitting(false);
  };

  const handleSubmit2 = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  await sendPasswordResetEmail(auth, email2)
    .then(() => {
    setGoodnote(true);
    count.current = 0;
    setNotific("Please check your email for the password reset link.");
    setShownote(true);
    donthandleReset();
    })
    .catch((err) => {
    setGoodnote(false);
    setNotific("An error occured. Please try again!");
    setShownote(true);
    });
  };

  const navigatehome = () => {
    navigate("/");
  };

  useEffect(() => {
    if (shownote === true) {
      var startTime = new Date().getTime();
      var interval = setInterval(function () {
        if (new Date().getTime() - startTime > 12000) {
          clearInterval(interval);
          return;
        }
        count.current++;
        if (count.current < 7) {
          setShownote(true);
        }
        if (count.current > 8) {
          setShownote(false);
        }
      }, 1000);
    }
  });
  

  return (
    <div style={{ overflowX: "hidden" }}>
      <Modal show={showModal} onHide={handleModalClose} centered={true}>
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="flex justify-center items-center align-center text-center p-2">
            <BsEmojiFrown
              size={50}
              color="#047E35"
              className="flex justify-center items-center "
            />
          </div>

          <div>{modalContent}</div>
        </Modal.Body>
      </Modal>
      <Modal show={showNotification} centered={true}>
        <Modal.Body style={{ marginTop: "1rem" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {notification}
            <div style={{ marginTop: "1rem" }}>
              <button
                onClick={handleCloseNotification}
                style={{
                  backgroundColor: "#047E35",
                  color: "white",
                  padding: "0.5rem 1rem",
                  borderRadius: "0.25rem",
                  cursor: "pointer",
                  border: "none",
                  marginRight: "1rem",
                }}
              >
                Ok
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {goodnote ? (
        <>
          <div
            className={shownote ? "text-center shownot" : "text-center hidenot"}
          >
            <div>
              <FontAwesomeIcon
                style={{ display: "inline", fontSize: "25px" }}
                icon={faCheck}
              />
              <h3 style={{ marginLeft: "10px", display: "inline" }}>
                {notific}
              </h3>
            </div>
          </div>

          {shownote ? (
            <>
              <br />
              <br />
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          <div
            className={
              shownote ? "text-center shownot2" : "text-center hidenot2"
            }
          >
            <div>
              <FontAwesomeIcon
                style={{ display: "inline", fontSize: "25px" }}
                icon={faXmark}
              />
              <h3 style={{ marginLeft: "10px", display: "inline" }}>
                {notific}
              </h3>
            </div>
          </div>

          {shownote ? (
            <>
              <br />
              <br />
            </>
          ) : (
            <></>
          )}
        </>
      )}

      {forgotpassword ? (
        <>
          <div className="container">
            <div className="row toptop">
              <div className="col-md-6">
                <div className="firsthalf">
                  <h2>Welcome Back!</h2>
                  <h4>
                    Our students also find employment at reputable companies:
                  </h4>

                  <div className="row">
                    <div className="col">
                      <img src="../../images/Microsoft.png" alt="microsoft" />
                    </div>
                    <div className="col">
                      <img src="../../images/Telsa.png" alt="telsa" />
                    </div>
                    <div className="col">
                      <img src="../../images/roter.png" alt="roter" />
                    </div>
                    <div className="col">
                      <img src="../../images/Wise.png" alt="wise" />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <img src="../../images/Apple.png" alt="apple" />
                    </div>
                    <div className="col">
                      <img src="../../images/Amazon.png" alt="amazon" />
                    </div>
                    <div className="col">
                      <img src="../../images/Google.png" alt="google" />
                    </div>
                    <div className="col">
                      <img src="../../images/Netflix.png" alt="netflix" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="text-center">
                  <img
                    src="../../images/doyenifyAcademy.png"
                    onClick={navigatehome}
                    style={{ cursor: "pointer" }}
                    alt="acadlogo"
                  />
                  <h2 style={{ color: "#156614", marginTop: "18px" }}>
                    Reset Your Password
                  </h2>
                  <div className="secondhalftop">
                    <div className="text-center">
                      <p
                        onClick={donthandleReset}
                        style={{ cursor: "pointer", color: "green" }}
                      >
                        Back to Login
                      </p>
                      <form onSubmit={handleSubmit2}>
                        <div
                          style={{ marginBottom: "15px", marginTop: "15px" }}
                        >
                          <div style={{ float: "left" }}>
                            <p>Email</p>
                          </div>
                          <div className="textinputbody">
                            <FontAwesomeIcon
                              className="loginicon"
                              icon={faEnvelope}
                            />
                            <input
                              className="textinputs"
                              placeholder="Enter your email"
                              name="email"
                              value={email2}
                              type="email"
                              onChange={(e) => setEmail2(e.target.value)}
                              required
                            ></input>
                          </div>
                        </div>
                        <button
                          type="submit"
                          className="btn btn-success loginbtn"
                        >
                          Send Reset Link
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="container">
          <div className='ml-[100px] mt-10 '>
              <img
                    src="../../images/doyenifyAcademy.png"
                    onClick={navigatehome}
                    style={{ cursor: "pointer" }}
                    alt="acadlogo"
                  />
              </div>
            <div className="row toptop">
              <div className="col-md-6">
              
                <div className="firsthalf">
                  <h2>Welcome Back!</h2>
                  <h4>
                    Our students also find employment at reputable companies:
                  </h4>

                  <div className="row">
                    <div className="col">
                      <img src="../../images/Microsoft.png" alt="microsoft" />
                    </div>
                    <div className="col">
                      <img src="../../images/Telsa.png" alt="telsa" />
                    </div>
                    <div className="col">
                      <img src="../../images/roter.png" alt="roter" />
                    </div>
                    <div className="col">
                      <img src="../../images/Wise.png" alt="wise" />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <img src="../../images/Apple.png" alt="apple" />
                    </div>
                    <div className="col">
                      <img src="../../images/Amazon.png" alt="amazon" />
                    </div>
                    <div className="col">
                      <img src="../../images/Google.png" alt="google" />
                    </div>
                    <div className="col">
                      <img src="../../images/Netflix.png" alt="netflix" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="text-center " style={{ marginBottom: "70px" }}>
                  

                  <h2 style={{ color: "#156614", marginTop: "30px" }}>Login</h2>
                  <div className="secondhalftop">
                    <div
                      style={{
                        display: "flex",
                        border: "1px solid #156614",
                        padding: "7px",
                        cursor: "pointer",
                      }}
                      onClick={handleClick}
                    >
                      <img
                        style={{ marginLeft: "20%", height: "25px" }}
                        src="../../images/Google.png"
                        alt="acadlogo"
                      />
                      <h5
                        style={{
                          paddingLeft: "12px",
                          paddingTop: "4px",
                          color: "#696969",
                        }}
                      >
                        Login with Google
                      </h5>
                    </div>
                    <div
                      onClick={SignInWithTwitter}
                      style={{
                        display: "flex",
                        border: "1px solid #156614",
                        padding: "7px",
                        cursor: "pointer",
                        marginTop: "5px",
                      }}
                    >
                      <img
                        style={{ marginLeft: "19%", height: "25px" }}
                        src="../../images/twitter.png"
                        alt="acadlogo"
                      />
                      <h5
                        style={{
                          paddingLeft: "12px",
                          paddingTop: "4px",
                          color: "#696969",
                        }}
                      >
                        Login with Twitter
                      </h5>
                    </div>
                  </div>

                  <div className="row secondhalfsecond">
                    <div className="col-4">
                      <hr />
                    </div>
                    <div className="col-4">or Log In with</div>
                    <div className="col-4">
                      <hr />
                    </div>
                  </div>

                  <div className="text-center">
                    <p style={{ color: "#FF0000" }}>{geterror}</p>
                  </div>

                  <form onSubmit={SignIn} className="secondhalfthird" autoComplete="off" noValidate>
                    <input type="text" name="fake_name" autoComplete="off" style={{ display: "none" }} />
                    <input type="email" name="fake_email" autoComplete="off" style={{ display: "none" }} />
                    <input type="password" name="fake_password" autoComplete="off" style={{ display: "none" }} />
                    <div style={{ marginBottom: "15px", marginTop: "15px" }}>
                      <div style={{ float: "left" }}>
                        <p>Email</p>
                      </div>
                      <div className="textinputbody">
                        <FontAwesomeIcon
                          className="loginicon"
                          icon={faEnvelope}
                        />
                        <input
                          type="email"
                          autoComplete="new-email"
                          className="textinputs"
                          placeholder="Enter your email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        ></input>
                      </div>
                    </div>

                    <div style={{ marginBottom: "20px" }}>
                      <div style={{ float: "left" }}>
                        <p>Password</p>
                      </div>

                      <div className="textinputbody">
                        <FontAwesomeIcon className="loginicon" icon={faLock} />
                        <input
                          type={hidepassword ? "password" : "text"}
                          autoComplete="new-password"
                          className="textinputs"
                          placeholder="Enter your password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                        ></input>
                        <div
                          className="eyeicon"
                          onClick={() => {
                            setHidepassword(!hidepassword);
                          }}
                        >
                          {hidepassword ? (
                            <>
                              <FontAwesomeIcon
                                className="loginicon"
                                icon={faEye}
                              />
                            </>
                          ) : (
                            <>
                              <FontAwesomeIcon
                                className="loginicon"
                                icon={faEyeSlash}
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6"></div>
                      <div className="col-md-6">
                        <p
                          style={{
                            display: "inline",
                            cursor: "pointer",
                            color: "#308f42",
                            float: "right",
                          }}
                          onClick={handleReset}
                        >
                          Forgot Password?
                        </p>
                      </div>
                    </div>

                    <button type="submit" className="btn btn-success loginbtn" disabled={isSubmitting}>
                      {isSubmitting ? "Logging in..." : "Log in"}
                    </button>
                    <div style={{ marginBottom: "10px" }}>
                      Don't have an Account?{" "}
                      <p
                        style={{
                          display: "inline",
                          cursor: "pointer",
                          color: "#308f42",
                        }}
                        onClick={toSignUp}
                      >
                        Sign Up
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SignIn;
